// Keep racial categories consistent across the homepage's charts and text,
// regardless of the order or number of categories in a filtered result.
const raceColors: Record<string, string> = {
  White: '#825af9',
  Black: '#35d9c3',
  Hispanic: '#4375ff',
  Asian: '#6d3dbf',
  'Native American': '#2cb1a1',
  'Middle Eastern': '#3658d4',
}

export function raceColor(label: string, fallback: string): string {
  return raceColors[label] ?? fallback
}
